import { useQuery } from '@tanstack/react-query';
import { gatewayService } from 'crono-fe-common/hooks/crono-extension/gateway';
import { CronoGatewayLinkedinSearchCompaniesAction } from 'crono-fe-common/types/crono-extension/linkedin';

const QUERY_KEY = 'linkedinCompanySearch';

/** The gateway's error as the gateway hooks word it. */
const toSearchError = (error: unknown) => {
  const message =
    error && typeof error === 'object' && 'message' in error
      ? error.message
      : null;

  if (message === 'missingCookie') {
    return new Error('Not logged in in Crono');
  }

  return new Error(typeof message === 'string' ? message : 'Unknown error');
};

/** The LinkedIn companies matching a name, searched through the browser extension. */
export default function useLinkedinCompanySearch(keywords: string) {
  return useQuery({
    queryKey: [QUERY_KEY, keywords],
    queryFn: async () => {
      try {
        return await gatewayService.execute<CronoGatewayLinkedinSearchCompaniesAction>(
          {
            target: 'linkedin',
            methodName: 'searchCompanies',
            params: { keywords },
            identifiers: null,
          },
        );
      } catch (error) {
        throw toSearchError(error);
      }
    },
    enabled: !!keywords,
    staleTime: 60_000,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
